import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% off selected items',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% off total order value',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Free item with an item',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Free item with an order value',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Buy one get one free half price',
  [OFFER_KIND.BOGO]: 'Buy one get one free',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} off selected items',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} off with an order value',
};
